import Termly from 'termly-namespace'

import unblockNode from './unblockNode'


/**
 * @param {Element} blockedNode
 * @param {object} [config]
 */
export default function unblockAndReplaceNode(blockedNode, config) {
  // A released node runs, and nothing can un-run it, so we note what it
  // answers to. Revoking that category later can only be enforced with a page
  // reload. `unblockByURLSubstring()` matches on `data-src` alone, so a node
  // can arrive here without any categories to record.
  const { categories } = blockedNode.dataset

  const node = unblockNode(blockedNode, config)

  // An element blocked with a placeholder `data-src` gets no address back, so
  // it never runs and a later revocation has nothing to stop. An element with
  // no `data-src` at all, like an inline script or a `data-href` stylesheet,
  // does run the moment it is put back.
  const hasLoaded = !blockedNode.hasAttribute('data-src') || node.hasAttribute('src')

  if ( categories && hasLoaded ) {
    Termly.addLoadedCategories(categories.split(','))
  }

  blockedNode.replaceWith(node)
}
